module.exports = __webpack_public_path__ + "img/icon-pen.bfec6c61.png";